<template>
<div class="inpBox">
  <div class="detailsTitle">
    <h4>修改订单</h4>
    <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
  <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <div class="addressBox" style="margin-top:20px">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>承运商信息</span>
        </h4>
    </div>
    <el-form-item label="承运商 :" prop="businessCompanyName" class="width1">
      <el-select  v-model="goodform.businessCompanyName" filterable placeholder="请选择" @change="jiesuanChange">
        <el-option v-for="item in cysList" :label="item.companyName" :value="item.companyName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="接单人:"  class="width1"   prop="businessUser">
      <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.businessUser"  ></el-input>
    </el-form-item>
    <el-button type="text"  @click="xuanzeJDR" style="margin-top: 8px;">选择</el-button>

    <hr>
    <!-- 地址组件 -->
    <addDizhi :goodform="goodform" ></addDizhi>
    <hr>
    <!-- 添加货物 -->
    <addGoodHuozhu :goodform="goodform" ></addGoodHuozhu>
     <div class="addressBox" style="margin-top:20px">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>运输要求</span>
        </h4>
        <el-form-item label="要求到达时间:" prop="arrivalTime" label-width="120px">
            <el-date-picker
              v-model="goodform.arrivalTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
        </el-form-item>
        <el-form-item label="需求车型:"   >
          <el-select  v-model="goodform.requiredModel" filterable placeholder="请选择">
            <el-option v-for="item in CXlist" :label="item.name" :value="item.name" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="需求车长:"   >
          <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
            <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="回单要求:" prop="receiptRequest"   >
          <el-select  v-model="goodform.receiptRequest"  placeholder="请选择">
             <el-option  label="纸质回单" value="纸质回单" ></el-option>
             <el-option  label="电子回单" value="电子回单" ></el-option>
             <el-option  label="否" value="否" ></el-option>
          </el-select>
        </el-form-item>
       <br>
        <el-form-item label="提货到场时间:" label-width="120px">
            <el-date-picker
              v-model="goodform.pickupTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="提货紧急程度:" label-width="120px">
          <el-radio-group v-model="goodform.urgencyFlag"    >
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">紧急</el-radio>
            <el-radio :label="2">加急</el-radio>
          </el-radio-group>
        </el-form-item>
        <br>
        <div>
          <el-tag style="margin:10px 10px;cursor: pointer;" v-for="item in elTags"
            :key="item"   @click="tagClick(item)" effect="plain">
            {{ item}}
          </el-tag>
        </div>
        <el-form-item label="备注:" class="remark" prop="remark" label-width="53px">
          <el-input  placeholder=""  maxlength="500" @blur="remarkFn"  v-model="goodform.remark"></el-input>
        </el-form-item>
      </div>
      <zhichu-huozhu :goodform="goodform" :kehuList="kehuList"></zhichu-huozhu>
      <hr>
      <uploadFiles :fileArr.sync='fileArr' :max=10></uploadFiles>

  </el-form>
  <div class="footerBtn">
    <el-button  class="bigBtn"  btnCode="004P001B001"  @click="back">取消</el-button>
    <el-button type="primary" class="bigBtn"  btnCode="004P001B000"  @click="saveFn">保存</el-button>
  </div>
  <!-- 接单人 -->
  <xuanzejiedanren :goodform="goodform" v-if="JDRflag" :JDRflag.sync='JDRflag' @jiesuanfangListFn="jiesuanfangListFn"></xuanzejiedanren>
</div>
</template>

<script>
import { selectTenantCompanyListByTenantCode, selectTMSTenantListByCustom } from '@/api/newCrm'
import { getDictionaryDetailList, updateOwnerOrder, findCustomerInfoList, getOrderInfo } from '@/api/newTMS'
import { cVLlist, cVTlist } from '@/api/vgs-driver2.0'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhiHuozhu.vue'
import addGoodHuozhu from '@/views/newTMS/publicFiles/wayAndOrder/addGoodHuozhu.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import xuanzejiedanren from '@/views/newTMS/publicFiles/wayAndOrder/xuanzejiedanren.vue'
import ZhichuHuozhu from '../../publicFiles/wayAndOrder/zhichuHuozhu.vue'
export default {
  components: {
    addDizhi, addGoodHuozhu, uploadFiles, xuanzejiedanren, ZhichuHuozhu
  },
  data () {
    return {
      id: this.$route.query.id,
      goodform: {
        goodsList: []
      },
      rules: {
        businessCompanyName: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ],
        orderBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        orderWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        // freightUnitPrice: [
        //   { required: true, message: '请输入运费单价', trigger: 'blur' }
        // ],
        // freightAmount: [
        //   { required: true, message: '请输入运费金额', trigger: 'blur' }
        // ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        businessUser: [
          { required: true, message: '请选择接单人', trigger: 'blur' }
        ],
        deliverPerson: [
          { required: true, message: '请输入发货人', trigger: 'blur' },
          { pattern: this.rule.xingming, message: '请输入正确的发货人' }
        ],
        deliverPhone: [
          { required: true, message: '请输入发货电话', trigger: 'blur' }
        ],
        receivingPerson: [
          { required: true, message: '请输入收货人', trigger: 'blur' },
          { pattern: this.rule.xingming, message: '请输入正确的收货人' }
        ],
        receivingPhone: [
          { required: true, message: '请输入收货电话', trigger: 'blur' }
        ]
      },
      cysList: [], // 承运商
      YWLXlist: [], // 业务类型
      CXlist: [], // 车型
      CClist: [], // 车长
      fileArr: [],
      JDRflag: false, // 接单人
      yonghuList: [],
      kehuList: [],
      deleteAttachmentsIds: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      elTags: ['轧辊架', '井字架', '棉被'],
      tagArr: []
    }
  },
  created () {
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    cVTlist().then(res => { this.CXlist = res })
    cVLlist().then(res => { this.CClist = res })
    selectTenantCompanyListByTenantCode({ tenantCode: localStorage.getItem('tenantCode'), businessCodes: this.global.businessCodeYS }).then(res => {
      this.cysList = res
    })
    if (this.id) { // 列表复制按钮跳转过来
      getOrderInfo({ orderBusinessId: this.id }).then(res => {
        this.goodform = res.tOrder

        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }

        this.goodform.deleteOrderGoodsRelIds = []
        this.tOrderBusiness = res.tOrderBusiness
        this.$set(this.goodform, 'productType', res.tOrder.productType.toString())
        this.$set(this.goodform, 'goodsList', res.goodslist)
        for (var key in res.tOrderBusiness) {
          if (key != 'id') {
            this.$set(this.goodform, key, res.tOrderBusiness[key])
          }
        }
        if (res.tOrderBusiness.expenditurePattern || res.tOrderBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tOrderBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tOrderBusiness.expenditurePatternName)
        }
        if (res.tOrderBusiness.freightPricingType || res.tOrderBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tOrderBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tOrderBusiness.freightPricingTypeName)
        }
        if (res.tOrderBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tOrderBusiness.freightUnitPrice / 100)
        }
        if (res.tOrderBusiness.freightAmount) {
          this.$set(this.goodform, 'freightAmount', res.tOrderBusiness.freightAmount / 100)
        }
        res.tAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })
        findCustomerInfoList({ businessType: 1, createDepartmentCode: this.goodform.businessUnitCode }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
          })
        })

        this.$set(this.goodform, 'oldsr', this.goodform.receivingPerson)
        this.$set(this.goodform, 'oldsh', this.goodform.receivingPhone)
        this.$set(this.goodform, 'oldfr', this.goodform.deliverPerson)
        this.$set(this.goodform, 'oldfh', this.goodform.deliverPhone)
      })
    }
  },
  mounted () {

  },
  methods: {
    tagClick (item) {
      this.tagArr.push(item)
      this.tagArr = Array.from(new Set(this.tagArr))
      this.$set(this.goodform, 'remark', this.tagArr.toString())
    },
    remarkFn () {
      if (!this.goodform.remark) {
        this.tagArr = []
      }
    },
    // 获取结算方列表
    jiesuanfangListFn (kehuList) {
      this.kehuList = kehuList
    },
    // 选择结算客户
    jiesuanChange (e) {
      let json = this.cysList.filter(item => item.companyName == this.goodform.businessCompanyName)
      this.goodform.businessCompanyCode = json[0].companyCode
      this.goodform.businessTenantCode = json[0].tenantCode
      this.goodform.businessTenantName = json[0].tenantName
      this.$set(this.goodform, 'businessUnitCode', '')
      this.$set(this.goodform, 'businessUnit', '')
      this.$set(this.goodform, 'businessUserId', '')
      this.$set(this.goodform, 'businessUser', '')
      this.$set(this.goodform, 'businessPhone', '')
      this.$set(this.goodform, 'payer', '')
      this.$set(this.goodform, 'payerTaxId', '')
      this.$set(this.goodform, 'payeeCode', '')
      this.$set(this.goodform, 'payer', this.goodform.businessCompanyName)
      this.$set(this.goodform, 'payerTaxId', json[0].companyTaxpayerNumber)
      this.$set(this.goodform, 'payerCode', json[0].tenantCode)
      getDictionaryDetailList({ tenantCode: json[0].tenantCode, dictionaryType: 'business_type' }).then(res => {
        let yewuleixingJson = res.filter(item => item.showName == '外库业务')
        if (yewuleixingJson.length == 1) {
          this.$set(this.goodform, 'orderBusinessType', yewuleixingJson[0].itemNo)
        }
      })
    },
    xuanzeJDR () {
      if (this.goodform.businessCompanyName) {
        this.JDRflag = true
      } else {
        this.$alert('请先选择承运商', '系统提示')
      }
    },
    saveFn () {
      if (!this.goodform.deliverAddressId) {
        this.$alert('请选择发货地址', '系统提示')
        return
      }
      if (!this.goodform.receivingAddressId) {
        this.$alert('请选择收货地址', '系统提示')
        return
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          let data = {}
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }

          data.tOrder = this.goodform

          data.goodslist = []// 修改只传新加的值
          this.goodform.goodsList.forEach(item => {
            if (!item.orderGoodsRelId) {
              data.goodslist.push(item)
            }
          })
          data.deleteOrderGoodsRelIds = this.goodform.deleteOrderGoodsRelIds
          data.deleteAttachmentsIds = this.deleteAttachmentsIds

          data.tOrderBusiness = this.tOrderBusiness// 把业务实体整个赋值

          if (this.goodform.oldsr != this.goodform.receivingPerson || this.goodform.oldsh != this.goodform.receivingPhone) {
            data.receivingFlag = 1
          }
          if (this.goodform.oldfr != this.goodform.deliverPerson || this.goodform.oldfh != this.goodform.deliverPhone) {
            data.deliverFlag = 1
          }

          this.tOrderBusiness.businessCompanyCode = this.goodform.businessCompanyCode
          this.tOrderBusiness.businessTenantCode = this.goodform.businessTenantCode
          this.tOrderBusiness.businessTenantName = this.goodform.businessTenantName
          data.tOrderBusiness.businessUnitCode = this.goodform.businessUnitCode
          data.tOrderBusiness.businessUnit = this.goodform.businessUnit
          data.tOrderBusiness.businessUserId = this.goodform.businessUserId
          data.tOrderBusiness.businessUser = this.goodform.businessUser
          data.tOrderBusiness.businessPhone = this.goodform.businessPhone
          data.tOrderBusiness.payer = this.goodform.payer
          data.tOrderBusiness.payerTaxId = this.goodform.payerTaxId
          data.tOrderBusiness.payerCode = this.goodform.payerCode

          data.tOrderBusiness.payeeTaxId = this.goodform.payeeTaxId
          data.tOrderBusiness.payee = this.goodform.payee
          data.tOrderBusiness.payeeCode = this.goodform.payeeCode
          data.tOrderBusiness.periodDays = this.goodform.periodDays

          data.tOrderBusiness.expenditurePattern = this.goodform.expenditurePattern
          data.tOrderBusiness.freightPricingType = this.goodform.freightPricingType
          data.tOrderBusiness.expenditurePatternName = this.goodform.expenditurePatternName
          data.tOrderBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
          data.tOrderBusiness.makeTicketYn = this.goodform.makeTicketYn
          data.tOrderBusiness.ticketSystemYn = this.goodform.ticketSystemYn
          data.tOrderBusiness.freightUnitPrice = this.goodform.freightUnitPrice
          data.tOrderBusiness.freightAmount = this.goodform.freightAmount

          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(data))
          this.fileArr.forEach(item => {
            imgfile.append('files', item.raw)
          })
          updateOwnerOrder(imgfile).then(res => {
            loading.close()
            this.$router.push({ name: 'customerOrder' })
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    back () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>

<style scoped lang='less'>
.width1  /deep/.el-input__inner{
  width: 260px;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
hr{
  margin-bottom: 20px;
}
/deep/.remark .el-input .el-input__inner{
  width: 788px;
}
/deep/.jiaoyan .el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
/deep/.el-range-editor{
  width: 430px;
}
</style>
